import * as React from 'react';
import { useWebComponent } from 'components/WebComponentRoot';
import { captureShowroomFrame } from 'utils/ui/captureShowroomFrame';

export function useCapture3DSnapshot(): () => Promise<Blob> {
  const { rootElement } = useWebComponent();

  return React.useCallback(async () => {
    const root: Document | ShadowRoot = rootElement ?? document;
    const el = root.querySelector<HTMLElement>('avp-3dws-deck');
    if (!el) {
      throw new Error('avp-3dws-deck element not found');
    }
    return captureShowroomFrame(el);
  }, [rootElement]);
}
